import { FullscreenOutlined } from '@ant-design/icons';
import React from 'react';

// Open in new tab
const FullPageLink = ({ url }) => (
  <div className="fullpage-link">
    <a
      href={url}
      onClick={(e) => {
        e.preventDefault();
        window.open(url, '_blank').focus();
      }}
    >
      Full page
      <FullscreenOutlined style={{ marginLeft: '4px', top: '1px', position: 'relative' }} />
    </a>
  </div>
);

export default FullPageLink;
